CustomTC.define('jquery/var/rnotwhite',[],function() {
	return (/\S+/g);
});

